import React from "react";
import { IntercomAPI } from 'react-intercom';

import HeaderComponent from "../../shared/header/components/HeaderComponent";
import MenuComponent from "../../menu/components/MenuComponent";

import FooterComponent from "../../shared/footer/components/FooterComponent";
import OrderService from "../../../services/OrdersService";

import "../../order/styles/OrderViewComponent.scss";
import OrderItem from "../../order/components/OrderItem"
import OrderSummary from "../../order/components/OrderSummary"
import SpinnerComponent from "../../shared/spinner";

export default class OrderViewComponent extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            isLoading: false,
            orders: [],
            orderService: new OrderService(),
            selectedOrder: null,
            message: "",
            nextPage: false,
            isLoadingMore: false,
            currentTab: "current",
            pastOrder: [],
            feedBackOrder: false,
            sellerName: ""
        }
        this.loadMoreOrders = this.loadMoreOrders.bind(this)
    }

    async getOrders(){
      this.setState({ isLoading: true });
        let response = await this.state.orderService.getOrders();
        const { id } = this.props.match.params

        this.setState({
           isLoading: false,
           orders: response.data.results,
           nextPage: response.data.pagination.next,
           selectedOrder: response.data.results[0]
        });

        if (response.data.results.length > 0){
          let currentOrder = response.data.results[0]
          if(id){
            let selectedOrder = response.data.results.find(item => parseInt(item.id) === parseInt(id))
            if (selectedOrder){
              currentOrder = selectedOrder
            }
          }
          var metadata = {
            cartId: currentOrder.id,
            buyerName: currentOrder.buyer.name,
            sellerName: currentOrder.seller.name,
          }
          IntercomAPI('trackEvent', 'access-order-page', metadata);
        }
        if (id){
          this.selectOrder(id)
        }

        this.setState({ isLoading: false })
    }
    loadMoreOrders(){
      if(this.state.currentTab !== "current") {
          this.getMorePastOrders();
      } else {
          this.getMoreOrders();
      }
    }
    getMoreOrders(){
      this.setState({isLoadingMore: true})
      this.state.orderService.getOrders(this.state.nextPage).then((response)=>{
        this.setState({
          nextPage: response.data.pagination.next,
          isLoadingMore: false,
          orders: [
              ...this.state.orders,
              ...response.data.results,
            ],
        })
      });
    }

    getMorePastOrders(){
      this.setState({isLoadingMore: true})
      this.state.orderService.getPastOrder(this.state.nextPage).then((response)=>{
        this.setState({
          nextPage: response.data.pagination.next,
          isLoadingMore: false,
          orders: [
              ...this.state.orders,
              ...response.data.results,
            ],
        })
      });
    }



    selectOrder(id){
        let selectedOrder = this.state.orders.find(item => parseInt(item.id) === parseInt(id));
        this.setState({ selectedOrder: selectedOrder });
    }

    componentWillMount(){
        this.setState({ isLoading: true });
        this.getOrders();
    }

    changeTab(tab){
        this.setState({ currentTab: tab, nextPage: false });
        if(tab !== "current") {
            this.getPastOrder();
        } else {
            this.getOrders();
        }
    }

    async getPastOrder() {
        this.setState({ isLoading: true });
        let response = await this.state.orderService.getPastOrder();

        this.setState({
          isLoading: false,
           orders: response.data.results,
           nextPage: response.data.pagination.next,
           selectedOrder: response.data.results[0]
        });

    }

    render() {
        return(
            <React.Fragment>
                <HeaderComponent />
                <MenuComponent />

                        <div id="order">
                            <div className="order-brands">
                                <div className="order-box-title">
                                    <div onClick={() => this.changeTab("current")} className={`tab ${(this.state.currentTab === "current") ? `active` : ``}`}>CURRENT ORDERS</div>
                                    <div onClick={() => this.changeTab("past")} className={`tab ${(this.state.currentTab === "past") ? `active` : ``}`}>PAST ORDERS</div>
                                </div>

                                {
                                    this.state.isLoading ? (
                                        <SpinnerComponent/>
                                    ) : (
                                        <>
                                        {this.state.orders.map((item, index) => (
                                          <OrderItem key={index} item={item}
                                          selectOrder={this.selectOrder.bind(this)}
                                          isActive={typeof this.state.selectedOrder != 'undefined' && this.state.selectedOrder.id === item.id}
                                          />
                                        ))}
                                        {this.state.nextPage ? (
                                          <div onClick={this.loadMoreOrders} className="load-more">
                                            LOAD MORE
                                            {this.state.isLoadingMore &&
                                              <div className="loader"></div>
                                            }
                                          </div>
                                        ):(
                                          <div className="no-more-orders">
                                            No more orders
                                            </div>
                                          )}
                                          </>
                                        )

                                    }
                            </div>
                            {this.state.isLoading ? (
                              <SpinnerComponent/>
                            ):(
                              <>
                              {this.state.selectedOrder ?
                                (<OrderSummary order={this.state.selectedOrder} />):(
                                  <div className="no-orders">No orders yet.</div>
                                )
                              }
                              </>
                            )

                            }

                        </div>

                <FooterComponent/>
            </React.Fragment>
        );
    }
}
